module.exports = __webpack_public_path__ + "img/Cover image-image.66158e55.jpg";